// Import model
import { CreateLeadNoteRequest } from '../models/CreateLeadNoteRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateLeadNoteRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateLeadNoteRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateLeadNoteRequest instance
   */
  static deserialize(json: string): CreateLeadNoteRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateLeadNoteRequest instance
   */
  static fromObject(obj: any): CreateLeadNoteRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateLeadNoteRequest');
    }


    const instance: CreateLeadNoteRequest = {
      parentObjectId: obj['parentObjectId'] as string,
      flowId: obj['flowId'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      content: obj['content'] as string | undefined,
      description: obj['description'] as string | undefined,
      name: obj['name'] as string,
      type_: obj['type'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
      creatorId: obj['creatorId'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateLeadNoteRequest instances
   */
  static deserializeArray(json: string): CreateLeadNoteRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateLeadNoteRequest instance to a JSON string
   */
  static serialize(instance: CreateLeadNoteRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateLeadNoteRequest instance to a plain object
   */
  static toObject(instance: CreateLeadNoteRequest): any {
    return {
      'parentObjectId': instance.parentObjectId,
      'flowId': instance.flowId,
      'objectStatusId': instance.objectStatusId,
      'content': instance.content,
      'description': instance.description,
      'name': instance.name,
      'type': instance.type_,
      'contentType': instance.contentType,
      'creatorId': instance.creatorId,
      'entityId': instance.entityId,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
    };
  }

  /**
   * Serializes an array of CreateLeadNoteRequest instances to a JSON string
   */
  static serializeArray(instances: CreateLeadNoteRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
